/** @format */

import axiosInstance from './axios';

export async function getFileStats(payload) {
  const response = await axiosInstance.post(
    'retailware_js/data_details/data_details/v2.2',
    payload
  );
  return response;
}
